import { render, staticRenderFns } from "./NewOrg.vue?vue&type=template&id=4f074ada&scoped=true&"
import script from "./NewOrg.vue?vue&type=script&lang=js&"
export * from "./NewOrg.vue?vue&type=script&lang=js&"
import style0 from "./NewOrg.vue?vue&type=style&index=0&id=4f074ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f074ada",
  null
  
)

export default component.exports